import { Box, styled } from '@mui/material';
import { StepStatus } from './types';

const getStepColor = (theme: any, status: StepStatus): string => {
  switch (status) {
    case StepStatus.COMPLETED:
      return theme.palette.success.main;
    case StepStatus.ACTIVE:
      return theme.vars.palette.background.success;
    case StepStatus.INACTIVE:
    default:
      return theme.vars.palette.common.sidebarBorder;
  }
};

export const TimelineContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  height: '100%',
}));

export const ProcessContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(2),
}));

export const ProcessItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const ProcessInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: '0 1 20%',
});

export const StepsContainer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  position: 'relative',
  overflowX: 'auto',
  flex: '1 0 auto',
});

export const StepItemIcon = styled(Box)<{ status: StepStatus }>(({ theme, status }) => ({
  backgroundColor: getStepColor(theme, status),
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  zIndex: 1,
  ...(status === StepStatus.ACTIVE && {
    border: `1px solid ${theme.palette.success.main}`,
  }),
}));

export const StepItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  position: 'relative',
  zIndex: 1,
  minWidth: '130px',
  width: '130px',
  flex: '0 0 auto',
  '&:not(:last-child)::before': {
    content: '""',
    position: 'absolute',
    top: '9px',
    left: '0',
    right: '0',
    height: '1px',
    backgroundColor: theme.palette.text.secondary,
    zIndex: 0,
  },
}));
